import { useContext } from 'react'
import { FontContext, type FontContextValue } from './font-context'

export type { FontContextValue } from './font-context'

export function useFonts(): FontContextValue {
  const ctx = useContext(FontContext)

  if (!ctx) {
    throw new Error('useFonts must be used within FontProvider')
  }

  return ctx
}

/** Safe for TextRenderer when FontProvider is absent (tests / storybook). */
export function useFontsOptional(): FontContextValue | null {
  return useContext(FontContext)
}
